import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { CustomComponent, ngHelper } from '@cakeiteasy/web-utils';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'ui-mobile-single-counter',
  templateUrl: './ui-mobile-single-counter.component.html',
  styleUrls: ['./ui-mobile-single-counter.component.scss']
})
export class UiMobileSingleCounterComponent extends CustomComponent implements OnChanges, OnInit {
  @Input() minCount: number = 1;
  @Input() maxCount: number | null = null;
  @Input() step: number = 1;
  @Input() count: number;
  @Input() disableZeroCount = false;
  @Input() isAllowEnterCounter: boolean;
  @Input() isPlusDisabled = false;

  @Output() onCountUpdated = new EventEmitter<number>();

  public positiveNumberPattern = /^\+?([1-9]\d*)$/;
  public countChange$ = new Subject<number>();

  ngOnInit() {
    this.addSubscriber(
      this.countChange$.pipe(debounceTime(900))
        .subscribe((count: number) => this.updateCount(count))
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'minCount', (minCount) => {
      // set timeout to prevent expression changing on component init
      setTimeout(() => {
        if (!this.count || this.count < minCount) {
          this.count = minCount;
          this.setCount(minCount);
        }
      });
    });
  }

  public shiftCount(isIncrease) {
    let shift = 0;

    if (isIncrease) {
      shift = this.count === 0 ? this.minCount || this.step : this.step;
    } else {
      shift = -(this.count === this.minCount ? this.minCount : this.step);
    }

    const newValue = this.count + shift;
    this.count = this._hasMaxCount() && this.maxCount < newValue ? this.maxCount : newValue;

    this.setCount(this.count);
  }

  public setCount(newCount) {
    this.onCountUpdated.emit(newCount);
  }

  public minusDisablingCheck() {
    return this.disableZeroCount && ((this.count - this.step) < this.minCount || this.count - this.step <= 0);
  }

  public plusDisablingCheck() {
    return this._hasMaxCount() && this.count >= this.maxCount;
  }

  public updateCount(count: number) {
    if (this._hasMaxCount() && count > this.maxCount) {
      this.count = this.maxCount;
    }
    if (this.minCount && count < this.minCount) {
      this.count = this.minCount;
    }
    this.setCount(this.count);
  }

  private _hasMaxCount(): boolean {
    return this.maxCount !== null;
  }
}
